import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import PublicLayout from "../../components/public/Layout/layout";
import Header from "../../components/student/Header/index";
import Categories from "../../containers/student/home/categories";
import RecordesComp from "../../containers/student/home/recordes";
import { getUserDataRequest } from "../../modules/user/Actions";

const Home = () => {
  const dispatch = useDispatch();
  const token = window.localStorage.getItem("token");
  const userData = useSelector((state) => state.user.userData);
  const [selectedDepartment, setSelectedDepartment] = useState(null);

  useEffect(() => {
    if (token) {
      dispatch(getUserDataRequest());
    }
  }, [token]);

  return (
    <PublicLayout
      color="white"
      bg="main_1"
      register={userData?.id ? false : true}
    >
      <Header />
      <Categories
        selectedDepartment={selectedDepartment}
        onSelectDepartment={setSelectedDepartment}
      />
      {/* <RegisterComp /> */}
      <RecordesComp />
      {/* <SummeryComp /> */}
      {/* <StudentComp /> */}
      {/* <ReviewsComp /> */}
      {/* <AboutUs />
      <ContsctUs />
      <News /> */}
    </PublicLayout>
  );
};

export default Home;
